<script setup lang="ts">
  import AlertContent from './AlertContent.vue';

  type AlertVariant = 'info' | 'success' | 'warning' | 'error';

  withDefaults(
    defineProps<{
      variant: AlertVariant;
      title: string;
      message: string;
      action?: {
        text: string;
        onClick: () => void;
        closeOnClick?: boolean;
      };
      autoClose?: number | boolean;
      dismissible?: boolean;
      lines?: 'single' | 'multiple';
    }>(),
    {
      action: undefined,
      autoClose: false,
      dismissible: false,
      lines: 'single',
    },
  );

  const emit = defineEmits<{ close: [] }>();
  const visible = defineModel<boolean>('visible', { default: true });

  const handleClose = (): void => {
    visible.value = false;
    emit('close');
  };
</script>

<template>
  <transition name="bv-alert-grow">
    <alert-content
      v-if="visible"
      :action="action"
      :auto-close="autoClose"
      :close-toast="handleClose"
      free-width
      :hide-close-btn="!dismissible"
      :lines="lines"
      :message="message"
      :title="title"
      :variant="variant"
    />
  </transition>
</template>

<style scoped>
  .bv-alert-grow-enter-active,
  .bv-alert-grow-leave-active {
    transform-origin: top;
    transition:
      transform 300ms ease,
      opacity 300ms ease;
  }

  .bv-alert-grow-enter-from,
  .bv-alert-grow-leave-to {
    transform: scaleY(0);
    opacity: 0;
  }
</style>
